import HeroBanner from "../components/HeroBanner";
import Categories from "../components/Categories";
import FeaturedProducts from "../components/FeaturedProducts";
import "../css/home.css";
import AnnouncementBar from "../components/AnnouncementBar";
import FlashSale from "../components/FlashSale";
import NewArrivals from "../components/NewArrivals";
import TrendingProducts from "../components/TrendingProducts";
import WhyChooseUs from "../components/WhyChooseUs";
function Home() {
  return (
    <div className="home-page">
<AnnouncementBar />
<HeroBanner />
  <FlashSale />
<NewArrivals />
      <TrendingProducts />
<WhyChooseUs />

      <section className="home-section">
        <Categories />
      </section>

      <section className="home-section">
        <FeaturedProducts />
      </section>
    </div>
  );
}

export default Home;